import { render, staticRenderFns } from "./CreateProposedHaulageLeadTimeDialog.vue?vue&type=template&id=1bbd2f56&scoped=true&"
import script from "./CreateProposedHaulageLeadTimeDialog.vue?vue&type=script&lang=js&"
export * from "./CreateProposedHaulageLeadTimeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd2f56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VContainer,VDialog,VForm})
